/*项目辅导*/
import axios from "@/api/index";
let method = 'GET';
/*资金申报--企业获得补贴排行榜列表*/
export const businessesSubsidiesLeaderboard=data=>axios.post('/home/rest/RevisionOneHome/businessesSubsidiesLeaderboard',data)
/*资金申报--惠企政策申报排行榜列表*/
export const policyDeclarationLeaderboard=data=>axios.post('/home/rest/RevisionOneHome/policyDeclarationLeaderboard',data)
/*重点项目申报政策列表 / 资金申报政策列表*/
export const newFundingSubsidyPolicyZhongDianZhengCeList=data=>axios.post('/home/rest/RevisionOneHome/newFundingSubsidyPolicyZhongDianZhengCeList',data)
/*资金补贴政策-重点项目申报部门列表*/
export const newPolicyDepartmentList=data=>axios.post('/home/rest/RevisionOneHome/newPolicyDepartmentList',data)
/*资金补贴政策列表-按时间查询*/
export const policyForTime=data=>axios.get('/home/rest/RevisionOneHome/policyForTime',data)
/*企业获得补贴--补贴详情列表*/
export const subsidiesForDetailsList=data=>axios.post('/home/rest/RevisionOneHome/subsidiesForDetailsList',data)
/*资金补贴政策详情*/
export const newFundingSubsidyPolicyInfo=data=>axios.post('/home/rest/RevisionOneHome/newFundingSubsidyPolicyInfo',data)
/*APP提交资金申报申请*/
export const submitFundingDeclarationApply=data=>axios.post('/versions/rest/PcDeclaration/submitFundingDeclarationApply',data)